import { Validator } from '@vista-digital/validator';
import { iconAssetValidator } from '../../../validators/icon-asset';
export const defaultOccPlaceholderAssets = {
    eventGallery: {
        name: 'event-gallery-placeholder',
        viewBox: '0 0 600 338'
    },
    eventPoster: {
        name: 'event-poster-placeholder',
        viewBox: '0 0 200 300'
    },
    filmAdvertisement: {
        name: 'film-advertisement-placeholder',
        viewBox: '0 0 660 300'
    },
    filmBackdrop: {
        name: 'film-backdrop-placeholder',
        viewBox: '0 0 660 300'
    },
    filmPoster: {
        name: 'film-poster-placeholder',
        viewBox: '0 0 200 300'
    },
    filmStill: {
        name: 'film-still-placeholder',
        viewBox: '0 0 660 300'
    },
    filmTitleTreatment: {
        name: 'film-title-treatment-placeholder',
        viewBox: '0 0 660 300'
    },
    itemImage: {
        name: 'item-image-placeholder',
        viewBox: '0 0 400 300'
    },
    memberPhoto: {
        name: 'member-photo-placeholder',
        viewBox: '0 0 120 120'
    },
    memberRewardImage: {
        name: 'member-reward-image-placeholder',
        viewBox: '0 0 160 90'
    },
    memberRewardThumbnail: {
        name: 'member-reward-thumbnail-placeholder',
        viewBox: '0 0 160 90'
    },
    redirectPaymentMethodIcon: {
        name: 'credit-card',
        viewBox: '0 0 32 24'
    },
    siteGallery: {
        name: 'site-gallery-placeholder',
        viewBox: '0 0 660 300'
    }
};
export const occPlaceholderAssetsValidator = Validator.object({
    eventPoster: iconAssetValidator,
    eventGallery: iconAssetValidator,
    filmAdvertisement: iconAssetValidator,
    filmBackdrop: iconAssetValidator,
    filmPoster: iconAssetValidator,
    filmStill: iconAssetValidator,
    filmTitleTreatment: iconAssetValidator,
    itemImage: iconAssetValidator,
    memberPhoto: iconAssetValidator,
    memberRewardImage: iconAssetValidator,
    memberRewardThumbnail: iconAssetValidator,
    redirectPaymentMethodIcon: iconAssetValidator,
    siteGallery: iconAssetValidator
});
//# sourceMappingURL=placeholder-assets.js.map